import { parse } from 'query-string';

export const getQueryStringValue = (
  key,
  queryString = window.location.search
) => {
  const values = parse(queryString);
  return values[key];
};
